import axios from "axios";
import { useState } from "react";
import ReactDOM from "react-dom";
import SignOutDialog from "./pages/Utils/SignOutDialog";

// local Base URL for the API
// export const BASE_URL = "http://manpowerdevbk.athithishala.com/graphql/";

// export const EXPORT_BASE_URL = "http://manpowerdevbk.athithishala.com";

//test url
// export const BASE_URL = "http://manpowertestbk.athithishala.com/graphql/";

// export const EXPORT_BASE_URL = "http://manpowertestbk.athithishala.com";

// Production Live Base URL for the API
export const BASE_URL = "https://takecarebk.soucient.com/graphql/";

export const EXPORT_BASE_URL = "https://takecarebk.soucient.com";


// Create Axios client
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor (Add token dynamically)
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isDialogOpen = false; // Flag to track if the dialog is already open

const showDialog = async () => {
  if (isDialogOpen) {
    return new Promise((resolve) => resolve(false)); // Resolve immediately if dialog is already open
  }

  isDialogOpen = true;

  return new Promise((resolve) => {
    const SignOutPopup = () => {
      const [open, setOpen] = useState(true);

      const handleConfirm = () => {
        setOpen(false);
        isDialogOpen = false;
        resolve(true); // User confirmed
        setTimeout(() => {
          window.location.href = "/sign-in";
        }, 0);
      };
      return <SignOutDialog open={open} onConfirm={handleConfirm} />;
    };

    // Render the dialog dynamically
    const container = document.createElement("div");
    document.body.appendChild(container);
    const unmount = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container); // Clean up DOM
    };
    ReactDOM.render(<SignOutPopup />, container);

    resolve.finally(() => {
      isDialogOpen = false;
      unmount();
    });
  });
};

// Response Interceptor (Handle token expiration)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip login endpoint from refresh logic
    if (originalRequest.url.includes("auth/login")) {
      return Promise.reject(error);
    }

    // If 401 and not retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = sessionStorage.getItem("refreshToken");
      if (!refreshToken) {
        console.error("No refresh token available. Redirecting to sign-in.");
        const confirm = await showDialog();
        if (confirm) window.location.href = "/sign-in";
        return Promise.reject(error);
      }

      try {
        // GraphQL mutation string
        const mutation = `
          mutation RefreshToken($refreshToken: String!) {
  refreshAccessToken(refreshToken: $refreshToken) {
    success
    message
    token
  }
}
        `;

        // Variables object
        const variables = { refreshToken };

        // Make GraphQL request using your sendRequest helper
        const data = await sendRequest(mutation, variables);

        const newAccessToken = data?.refreshToken?.accessToken;

        if (newAccessToken) {
          sessionStorage.setItem("token", newAccessToken);

          // Retry original request with new token
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return apiClient(originalRequest);
        } else {
          console.error("Failed to refresh token. Redirecting to sign-in.");
          const confirm = await showDialog();
          if (confirm) window.location.href = "/sign-in";
          return Promise.reject(error);
        }
      } catch (err) {
        console.error("Error refreshing token:", err);
        const confirm = await showDialog();
        if (confirm) window.location.href = "/sign-in";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

// Generic GraphQL request handler
export const sendRequest = async (query, variables = {}) => {
  try {
    const response = await apiClient.post("", { query, variables });
    if (response.data.errors) {
      throw new Error(
        response.data.errors.map((err) => err.message).join(", ")
      );
    }
    return response.data.data;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};

// Fetch all entities with dynamic fields
export const fetchAll = async (query) => {
  return await sendRequest(query);
};

// Fetch an entity by ID with dynamic fields
export const fetchById = async (query, variables) => {
  return await sendRequest(query, variables);
};

// Fetch an entity by ID with dynamic fields
export const Logout = async (query, variables) => {
  return await sendRequest(query, variables);
};

// Create a new entity with dynamic fields
export const postItem = async (mutation, variables) => {
  return await sendRequest(mutation, variables);
};

export const FetchDataGet = async (mutation, variables) => {
  return await sendRequest(mutation, variables);
};

// Update an entity with dynamic fields
export const updateItem = async (mutation, variables) => {
  return await sendRequest(mutation, variables);
};

// Delete an entity
export const deleteItem = async (mutation, variables) => {
  return await sendRequest(mutation, variables);
};
